module.exports = __webpack_public_path__ + "static/media/icon-newAccount.18441778.svg";